export default __webpack_public_path__ + "static/media/snapfood-loading.b89376f3.gif";